/* tslint:disable */
/* eslint-disable */
/**
 * Consolidate Legacy API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CustomFormField,
    CustomFormFieldFromJSON,
    CustomFormFieldFromJSONTyped,
    CustomFormFieldToJSON,
    GetAktResponseBase,
    GetAktResponseBaseFromJSON,
    GetAktResponseBaseFromJSONTyped,
    GetAktResponseBaseToJSON,
    GetAktResponseBaseObjects,
    GetAktResponseBaseObjectsFromJSON,
    GetAktResponseBaseObjectsFromJSONTyped,
    GetAktResponseBaseObjectsToJSON,
    GetAktResponseBaseRights,
    GetAktResponseBaseRightsFromJSON,
    GetAktResponseBaseRightsFromJSONTyped,
    GetAktResponseBaseRightsToJSON,
    GetAktResponseDocumentAllOf,
    GetAktResponseDocumentAllOfFromJSON,
    GetAktResponseDocumentAllOfFromJSONTyped,
    GetAktResponseDocumentAllOfToJSON,
    GetAktResponseDocumentAllOfMembers,
    GetAktResponseDocumentAllOfMembersFromJSON,
    GetAktResponseDocumentAllOfMembersFromJSONTyped,
    GetAktResponseDocumentAllOfMembersToJSON,
} from './';

/**
 * 
 * @export
 * @interface GetAktResponseDocument
 */
export interface GetAktResponseDocument {
    /**
     * 
     * @type {number}
     * @memberof GetAktResponseDocument
     */
    addAttachment: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetAktResponseDocument
     */
    allowobjects?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GetAktResponseDocument
     */
    aktid: number;
    /**
     * 
     * @type {string}
     * @memberof GetAktResponseDocument
     */
    aktname: string;
    /**
     * 
     * @type {number}
     * @memberof GetAktResponseDocument
     */
    aktsakt: number;
    /**
     * 
     * @type {number}
     * @memberof GetAktResponseDocument
     */
    akttype: number;
    /**
     * 
     * @type {string}
     * @memberof GetAktResponseDocument
     */
    alarmtime?: string;
    /**
     * 
     * @type {string}
     * @memberof GetAktResponseDocument
     */
    alarmtimeutc?: string;
    /**
     * 
     * @type {string}
     * @memberof GetAktResponseDocument
     */
    createdby?: string;
    /**
     * 
     * @type {string}
     * @memberof GetAktResponseDocument
     */
    creationdate?: string;
    /**
     * 
     * @type {Array<object>}
     * @memberof GetAktResponseDocument
     */
    attachments?: Array<object>;
    /**
     * 
     * @type {string}
     * @memberof GetAktResponseDocument
     */
    color: string;
    /**
     * 
     * @type {{ [key: string]: { [key: string]: CustomFormField; }; }}
     * @memberof GetAktResponseDocument
     */
    custom?: { [key: string]: { [key: string]: CustomFormField; }; };
    /**
     * 
     * @type {Array<object>}
     * @memberof GetAktResponseDocument
     */
    internalCCs?: Array<object>;
    /**
     * 
     * @type {boolean}
     * @memberof GetAktResponseDocument
     */
    morecontacts: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetAktResponseDocument
     */
    date: string;
    /**
     * 
     * @type {string}
     * @memberof GetAktResponseDocument
     */
    datelabel: string;
    /**
     * 
     * @type {number}
     * @memberof GetAktResponseDocument
     */
    hasfollowakt: number;
    /**
     * 
     * @type {string}
     * @memberof GetAktResponseDocument
     */
    icon: string;
    /**
     * 
     * @type {number}
     * @memberof GetAktResponseDocument
     */
    nextsteptype?: number;
    /**
     * 
     * @type {number}
     * @memberof GetAktResponseDocument
     */
    nextstepid?: number;
    /**
     * 
     * @type {string}
     * @memberof GetAktResponseDocument
     */
    nextstepname?: string;
    /**
     * 
     * @type {number}
     * @memberof GetAktResponseDocument
     */
    nextstepfiredby?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetAktResponseDocument
     */
    infomail?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetAktResponseDocument
     */
    yesInfo?: string;
    /**
     * 
     * @type {string}
     * @memberof GetAktResponseDocument
     */
    noInfo?: string;
    /**
     * 
     * @type {string}
     * @memberof GetAktResponseDocument
     */
    stepcomment?: string;
    /**
     * 
     * @type {string}
     * @memberof GetAktResponseDocument
     */
    steptargetuser?: string;
    /**
     * 
     * @type {string}
     * @memberof GetAktResponseDocument
     */
    steptargetlist?: string;
    /**
     * 
     * @type {Array<GetAktResponseBaseObjects>}
     * @memberof GetAktResponseDocument
     */
    objects?: Array<GetAktResponseBaseObjects>;
    /**
     * 
     * @type {number}
     * @memberof GetAktResponseDocument
     */
    prevakt: number;
    /**
     * 
     * @type {number}
     * @memberof GetAktResponseDocument
     */
    priority: number;
    /**
     * 
     * @type {number}
     * @memberof GetAktResponseDocument
     */
    processid?: number;
    /**
     * 
     * @type {number}
     * @memberof GetAktResponseDocument
     */
    projectid: number;
    /**
     * 
     * @type {string}
     * @memberof GetAktResponseDocument
     */
    projectname?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetAktResponseDocument
     */
    projectvisible: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetAktResponseDocument
     */
    resp: string;
    /**
     * 
     * @type {GetAktResponseBaseRights}
     * @memberof GetAktResponseDocument
     */
    rights: GetAktResponseBaseRights;
    /**
     * 
     * @type {number}
     * @memberof GetAktResponseDocument
     */
    secret: number;
    /**
     * 
     * @type {string}
     * @memberof GetAktResponseDocument
     */
    status: string;
    /**
     * 
     * @type {number}
     * @memberof GetAktResponseDocument
     */
    statusid: number;
    /**
     * 
     * @type {string}
     * @memberof GetAktResponseDocument
     */
    subject: string;
    /**
     * 
     * @type {string}
     * @memberof GetAktResponseDocument
     */
    workflowInfo?: string;
    /**
     * 
     * @type {string}
     * @memberof GetAktResponseDocument
     */
    workflowinfotimestamp: string;
    /**
     * 
     * @type {GetAktResponseDocumentAllOfMembers}
     * @memberof GetAktResponseDocument
     */
    members: GetAktResponseDocumentAllOfMembers;
}

export function GetAktResponseDocumentFromJSON(json: any): GetAktResponseDocument {
    return GetAktResponseDocumentFromJSONTyped(json, false);
}

export function GetAktResponseDocumentFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAktResponseDocument {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'addAttachment': json['addAttachment'],
        'allowobjects': !exists(json, 'allowobjects') ? undefined : json['allowobjects'],
        'aktid': json['aktid'],
        'aktname': json['aktname'],
        'aktsakt': json['aktsakt'],
        'akttype': json['akttype'],
        'alarmtime': !exists(json, 'alarmtime') ? undefined : json['alarmtime'],
        'alarmtimeutc': !exists(json, 'alarmtimeutc') ? undefined : json['alarmtimeutc'],
        'createdby': !exists(json, 'createdby') ? undefined : json['createdby'],
        'creationdate': !exists(json, 'creationdate') ? undefined : json['creationdate'],
        'attachments': !exists(json, 'attachments') ? undefined : json['attachments'],
        'color': json['color'],
        'custom': !exists(json, 'custom') ? undefined : json['custom'],
        'internalCCs': !exists(json, 'internalCCs') ? undefined : json['internalCCs'],
        'morecontacts': json['morecontacts'],
        'date': json['date'],
        'datelabel': json['datelabel'],
        'hasfollowakt': json['hasfollowakt'],
        'icon': json['icon'],
        'nextsteptype': !exists(json, 'nextsteptype') ? undefined : json['nextsteptype'],
        'nextstepid': !exists(json, 'nextstepid') ? undefined : json['nextstepid'],
        'nextstepname': !exists(json, 'nextstepname') ? undefined : json['nextstepname'],
        'nextstepfiredby': !exists(json, 'nextstepfiredby') ? undefined : json['nextstepfiredby'],
        'infomail': !exists(json, 'infomail') ? undefined : json['infomail'],
        'yesInfo': !exists(json, 'yes_info') ? undefined : json['yes_info'],
        'noInfo': !exists(json, 'no_info') ? undefined : json['no_info'],
        'stepcomment': !exists(json, 'stepcomment') ? undefined : json['stepcomment'],
        'steptargetuser': !exists(json, 'steptargetuser') ? undefined : json['steptargetuser'],
        'steptargetlist': !exists(json, 'steptargetlist') ? undefined : json['steptargetlist'],
        'objects': !exists(json, 'objects') ? undefined : ((json['objects'] as Array<any>).map(GetAktResponseBaseObjectsFromJSON)),
        'prevakt': json['prevakt'],
        'priority': json['priority'],
        'processid': !exists(json, 'processid') ? undefined : json['processid'],
        'projectid': json['projectid'],
        'projectname': !exists(json, 'projectname') ? undefined : json['projectname'],
        'projectvisible': json['projectvisible'],
        'resp': json['resp'],
        'rights': GetAktResponseBaseRightsFromJSON(json['rights']),
        'secret': json['secret'],
        'status': json['status'],
        'statusid': json['statusid'],
        'subject': json['subject'],
        'workflowInfo': !exists(json, 'workflowInfo') ? undefined : json['workflowInfo'],
        'workflowinfotimestamp': json['workflowinfotimestamp'],
        'members': GetAktResponseDocumentAllOfMembersFromJSON(json['members']),
    };
}

export function GetAktResponseDocumentToJSON(value?: GetAktResponseDocument | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'addAttachment': value.addAttachment,
        'allowobjects': value.allowobjects,
        'aktid': value.aktid,
        'aktname': value.aktname,
        'aktsakt': value.aktsakt,
        'akttype': value.akttype,
        'alarmtime': value.alarmtime,
        'alarmtimeutc': value.alarmtimeutc,
        'createdby': value.createdby,
        'creationdate': value.creationdate,
        'attachments': value.attachments,
        'color': value.color,
        'custom': value.custom,
        'internalCCs': value.internalCCs,
        'morecontacts': value.morecontacts,
        'date': value.date,
        'datelabel': value.datelabel,
        'hasfollowakt': value.hasfollowakt,
        'icon': value.icon,
        'nextsteptype': value.nextsteptype,
        'nextstepid': value.nextstepid,
        'nextstepname': value.nextstepname,
        'nextstepfiredby': value.nextstepfiredby,
        'infomail': value.infomail,
        'yes_info': value.yesInfo,
        'no_info': value.noInfo,
        'stepcomment': value.stepcomment,
        'steptargetuser': value.steptargetuser,
        'steptargetlist': value.steptargetlist,
        'objects': value.objects === undefined ? undefined : ((value.objects as Array<any>).map(GetAktResponseBaseObjectsToJSON)),
        'prevakt': value.prevakt,
        'priority': value.priority,
        'processid': value.processid,
        'projectid': value.projectid,
        'projectname': value.projectname,
        'projectvisible': value.projectvisible,
        'resp': value.resp,
        'rights': GetAktResponseBaseRightsToJSON(value.rights),
        'secret': value.secret,
        'status': value.status,
        'statusid': value.statusid,
        'subject': value.subject,
        'workflowInfo': value.workflowInfo,
        'workflowinfotimestamp': value.workflowinfotimestamp,
        'members': GetAktResponseDocumentAllOfMembersToJSON(value.members),
    };
}


